/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

 document.addEventListener('DOMContentLoaded', function() {
    if (!document.querySelector('.product__page')) return;

    document.documentElement.style.overflowY = '';
    document.documentElement.style.overflow = '';

    var page = document.querySelector('.product__page');
    var content = document.querySelector('.product__content');

    if (!page || !content) return;

    page.style.cssText += '; align-items: start !important;';
    content.style.cssText += '; position: sticky !important; top: 80px !important; align-self: start !important;';
  });
  

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
